<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-picture"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-picture-content" v-if="isShow">
                <div class="picture-content">
                    <div class="splide grid-item-1" id="picture-modal-slider"  v-if="campaignImage.length > 1">
                        <div class="splide__track">
                            <ul class="splide__list">
                                <li class="splide__slide main-slider" v-for="(image, k) in campaignImage" :key="'main_' + k">
                                    <div class="picture-modal-detail-img">
                                        <img :src="image.fullImageUrl" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="splide__arrows">
                            <button class="splide__arrow splide__arrow--prev">
                                <img src="../../../../assets/new/icon/arrow-l.svg"/>
                            </button>
                            <button class="splide__arrow splide__arrow--next">
                                <img src="../../../../assets/new/icon/arrow-r.svg"/>
                            </button>
                        </div>
                    </div>
                    <div class="grid-item-2">
                        <div class="title-modal">
                            <div class="campaign-name">
                                {{campaign.name}}
                            </div>
                            <div class="close-modal" @click="clickCancel()">
                                <img src="../../../../assets/new/icon/ic_round-close@2x.png"/>
                            </div>
                        </div>
                        <div class="splide mt-4" id="picture-modal-thumbnail-slider">
                            <div class="splide__track slider-width">
                                <ul class="splide__list">
                                    <li class="splide__slide" v-for="(image, k) in campaignImage" :key="k">
                                        <div class="picture-modal-thumbnail-img">
                                            <img :src="image.fullImageUrl" />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import Splide from '@splidejs/splide'; //https://splidejs.com/
// import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "PictureModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            message: '',
            btnOk: '',
            campaign: '',
            busModal: null,
            lbl: Locale.getLbl(),
            campaignImage: [],
            isShow: false
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        show: function(config) {
            this.campaign = config.campaign;
            this.$bvModal.show(this.modalId);
            this.initSlider();
            this.isShow = true;
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        initSlider: function() {
            this.campaignImage = this.campaign.pictures
            if (this.campaignImage.length > 1) {
                this.setSlider()
            }
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.main = new Splide('#picture-modal-slider', {
                    type: 'fade',
                    rewind: true,
                    heightRatio: 1,
                    pagination: false,
                    arrows: true,
                    cover: true,
                    autoWidth:true,
                    classes: {
                        arrow : 'splide__arrow arrows-icon-style',
                        prev  : 'splide__arrow--prev prev-icon-style',
                        next  : 'splide__arrow--next next-icon-style',
                    },
                });
                this.thumbnails = new Splide('#picture-modal-thumbnail-slider', {
                    rewind: true,
                    autoWidth: true,
                    isNavigation: true,
                    gap: 10,
                    pagination: false,
                    cover: true,
                    arrows: false,
                    breakpoints: {
                        640: {
                            autoWidth:true,
                        },
                    },
                });
                this.main.sync(this.thumbnails);
                this.main.mount();
                this.thumbnails.mount();
            })
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/baseImage.scss";
    @import "@/style/base/baseText.scss";
    @import "@/style/modal.scss";
    @import "./PictureModal.scss";
</style>
